function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "a",
  x1: "50%",
  x2: "50%",
  y1: "0%",
  y2: "100%"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0%",
  stopColor: "#AEFEFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "100%",
  stopColor: "#10BEE6"
})));

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "url(#a)",
  fillRule: "nonzero",
  d: "M10.964.043c5.916-.502 11.292 3.464 12.58 9.283h-1.957C20.325 4.59 15.83 1.47 10.97 1.96c-4.86.49-8.65 4.443-8.95 9.337C1.72 16.19 5 20.58 9.764 21.663c4.764 1.083 9.607-1.46 11.437-6.006h2.026c-1.866 5.658-7.612 9.06-13.449 7.963C3.941 22.523-.189 17.264.11 11.311.41 5.358 5.047.544 10.964.043zm8.487 7.366l-.004.005h.004l-.005.003-1.743 3.032h-2.16l.622-1.082-4.202.002-4.203.002 2.102 3.652 1.818 3.159 1.35 2.399-1.064 1.85-3.745-6.508-3.747-6.509 7.489-.001 7.488-.004zm-2.587 4.5l-1.155 2.01-.822 1.43 1.862 3.282-1.203 1.68-2.12-3.734-.702-1.221.003-.008-.003-.008h.008l.987-1.716h-1.896l-.96-1.714h6.001z"
});

const SvgIcGrc = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIcGrc, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ic-grc.7ddf8dd6.svg";
export { ForwardRef as ReactComponent };